import { Core, Decorative } from "@faire/design-tokens";
import styled, { css } from "styled-components";

export const NotificationDot = styled.div<{
  $right?: number;
  $top?: number;
  $color?: string;
}>`
  border-radius: 100%;
  border: 1px solid ${Core.border.muted};
  position: absolute;
  width: 8px;
  height: 8px;
  top: ${(props) =>
    props.$top
      ? css`
          ${props.$top}px
        `
      : css`19px`};
  right: ${(props) =>
    props.$right
      ? css`
          ${props.$right}px
        `
      : css`17px`};
  background-color: ${(props) =>
    props.$color ? props.$color : Decorative.shade.orange};
`;
